export default __webpack_public_path__ + "static/media/real_time_labor_guide_logo1.992ca9a7.png";